// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const remoteOptions = gql`
  query remoteOptions {
    userOptions @rest(type: "LiveDataOptions", path: "livedata/options") {
      localeLanguage
      unitSystem
      timeZone
    }
    languages @rest(type: "LiveDataLanguage", path: "livedata/languages") {
      code
      name
    }
  }
`;

export default remoteOptions;
